import MultipleSessionApi from '@/api/multipleSession'
import router from '@/router'
import {
  ROUTE_NAMES,
} from '@/constant/routes'
import role from '@/constant/role'

const actions = {
  publishNewSessionAction: async ({ commit }, payload) => {
    commit('setIsCreatingNewSession', true)
    try {
      await MultipleSessionApi.publishNewSession(payload)
    } finally {
      commit('setIsCreatingNewSession', false)
    }
  },
  getPresentationMasterByPresentationIdAction: async (_, payload) => {
    const resp = await MultipleSessionApi.getPresentationMasterByPresentationId(payload)
    return resp.body
  },
  getListSessionsByPresentationIdAction: async (_, payload) => {
    const resp = await MultipleSessionApi.getListSessionsByPresentationId(payload)
    return resp.body
  },
  getPresentationDetailBySessionAction: async (_, payload) => {
    const res = await MultipleSessionApi.getPresentationDetailBySession(payload)
    res.body.slides = res.body.Slides
    return res
  },
  setSelectedSession: async ({ state }, payload) => {
    state.isRenderedReport = false
    state.selectedSession = payload
    if (payload) {
      if (payload.isRoot) {
        state.selectedSession = null
      }
      router.replace({
        name: ROUTE_NAMES.PRESENTATION_REPORT,
        params: {
          id: payload.presentationId,
        },
      })
    }
    state.isRenderedReport = true
  },
  setDefaultSelectedSession: ({ state }, payload) => {
    state.selectedSession = payload
  },

  getListInstructorByPresentationIdAction: async (_, presentationId) => {
    const resp = await MultipleSessionApi.getListInstructorByPresentationId(presentationId)
    return resp.body.instructors.map((item) => {
      return {
        avatar: item.user.avatar,
        id: item.user.id,
        email: item.user.email,
        firstName: item.user.firstName,
        lastName: item.user.lastName,
        role: role.INSTRUCTOR,
        instructorId: item.instructorId,
      }
    })
  },

  createInstructorAction: async (_, payload) => {
    return MultipleSessionApi.createInstructor(payload.presentationId, {
      instructorEmails: payload.collaborators.emails,
    })
  },

  deleteInstructorAction: async (_, payload) => {
    return MultipleSessionApi.deleteInstructor(payload.presentationId, {
      instructorIds: payload.instructorIds,
    })
  },
}

export default actions
